webpackJsonp([107],{

/***/ "/4dZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Iby":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationDrawer_vue__ = __webpack_require__("6b8u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a0e687c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationDrawer_vue__ = __webpack_require__("NSlq");
function injectStyle (ssrContext) {
  __webpack_require__("NnJV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationDrawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a0e687c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationDrawer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2OTX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright"},[_vm._v("\n            Employee Self Service (ESS)\n            © Coded\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Jayvee Ayao at\n            "),_c('a',{attrs:{"href":"https://blueprintbusinesssolutionscorp.com/","target":"_blank"}},[_vm._v("Blueprint Business Solutions Corp")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2eGQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":250,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":250,"animation":"wave"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":50,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":50,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":50,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":50,"animation":"wave"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_vm._v("\n                    Attendance for "+_vm._s(new Date().toLocaleDateString())+"\n                ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3qaA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loader: true
    };
  },


  created: function created() {
    this.getCurentUser();
  },
  methods: {
    getCurentUser: function getCurentUser() {
      var _this = this;

      axios.get('api/getfullname').then(function (response) {
        _this.user = response.data;
        _this.loader = false;
      });
    },
    toggleNavigationBar: function toggleNavigationBar() {
      var vm = this;

      vm.$emit('toggleNavigationBar');
      console.log('response => ', vm);
      //alert('test')
    }
  }
});

/***/ }),

/***/ "4PIV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row justify-content-center mt-5"},[_c('div',{staticClass:"col-xl-2 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":175,"height":160,"animation":"wave"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center mt-5"},[_c('div',{staticClass:"col-xl-2 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":175,"height":160,"animation":"wave"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center mt-5"},[_c('div',{staticClass:"col-xl-2 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":175,"height":160,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":175,"height":160,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":175,"height":160,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":175,"height":160,"animation":"wave"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4ZQf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



var _this = this;

/* eslint-disable */
var auth = {
    namespaced: true,

    state: {
        isLoggedIn: !!localStorage.getItem('token'),
        user: []
    },

    getters: {},

    actions: {
        GET_USER: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
                var commit = _ref2.commit;

                var token, _ref3, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                token = localStorage.getItem('token');

                                if (!(token != null)) {
                                    _context.next = 7;
                                    break;
                                }

                                _context.next = 4;
                                return axios.get('api/userInfo');

                            case 4:
                                _ref3 = _context.sent;
                                data = _ref3.data;

                                commit('SET_USER', data);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function GET_USER(_x) {
                return _ref.apply(this, arguments);
            };
        }()
    },

    mutations: {
        SET_USER: function SET_USER(state, payload) {
            state.user = payload;
        },

        LOGIN_USER: function LOGIN_USER(state) {
            state.isLoggedIn = true;
        },
        LOGOUT_USER: function LOGOUT_USER(state) {
            state.isLoggedIn = false;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (auth);

/***/ }),

/***/ "6b8u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    toggle: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function data() {
    return {
      loader_menu: true
    };
  },
  created: function created() {
    //  this.supervisor_side()
    this.$store.dispatch('USER_AUTH/GET_USER');
    this.$store.dispatch('NOTIFICATION/NTE_NOTIFY_ME');
    this.$store.dispatch('NOTIFICATION/NTE_NOTIFY_ASM');
    this.$store.dispatch('NOTIFICATION/COACHING_COUNTER');
    this.$store.dispatch('NOTIFICATION/LOAD_REQUEST');
    this.$store.dispatch('NOTIFICATION/LOAD_PAYSLIP');
    this.$store.dispatch('NOTIFICATION/LOAD_EVALUATION');
    this.$store.dispatch('NOTIFICATION/LOAD_EVALUATION_ASM');
    this.$store.dispatch('NOTIFICATION/CONTRACT_MEMO_NOTIFY_ME');
    this.getCurrentUser();
  },


  methods: {
    logoutAction: function logoutAction() {
      var _this = this;

      var token = localStorage.getItem("token");
      axios.post('api/logout', { token: this.token }).then(function (resp) {
        if (resp.status == 200) {
          _this.$store.commit('USER_AUTH/LOGOUT_USER');
          localStorage.removeItem('token');
          localStorage.removeItem('emp_id');
          localStorage.removeItem('role_id');
          setTimeout(_this.$router.push({ name: 'Login-Layout' }), 6000);
        }
      });
    },
    getCurrentUser: function getCurrentUser() {
      var _this2 = this;

      axios.get('api/userInfo').then(function (response) {
        _this2.sub_department_id = response.data.sub_department_id;
        _this2.loader_menu = false;
        console.log('response => ', response);
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    isActive: function isActive(routeName) {
      return this.$route.name === routeName;
    },
    changeRoute: function changeRoute(routeName) {
      if (!routeName) return;
      return this.$router.push({ name: routeName });
    },
    logout_action: function logout_action() {
      var _this3 = this;

      axios.post('api/logout', {
        token: localStorage.getItem('token')
      }).then(function (resp) {
        localStorage.removeItem('token');
        localStorage.removeItem('emp_id');
        localStorage.removeItem('role_id');
        _this3.$store.commit('LOGOUT_USER', { module: 'USER_AUTH' });
        _this3.$router.push({ name: 'Login-Layout' });
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('NOTIFICATION', ['payslip_item', 'my_nte_item', 'asm_nte_item', 'coaching_item', 'post_request', 'evaluation_item', 'evaluation_item_asm', 'my_contract_memo_item']))
});

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Uc3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__ = __webpack_require__("nYKV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar__ = __webpack_require__("olwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        events: {
            default: function _default() {
                return [];
            }
        },

        eventSources: {
            default: function _default() {
                return [];
            }
        },

        editable: {
            default: function _default() {
                return true;
            }
        },

        selectable: {
            default: function _default() {
                return true;
            }
        },

        selectHelper: {
            default: function _default() {
                return true;
            }
        },

        header: {
            default: function _default() {
                return {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                };
            }
        },

        defaultView: {
            default: function _default() {
                return 'agendaWeek';
            }
        },

        sync: {
            default: function _default() {
                return false;
            }
        },

        config: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    computed: {
        defaultConfig: function defaultConfig() {
            var self = this;
            return {
                header: this.header,
                defaultView: this.defaultView,
                editable: this.editable,
                selectable: this.selectable,
                selectHelper: this.selectHelper,
                aspectRatio: 2,
                timeFormat: 'HH:mm',
                events: this.events,
                eventSources: this.eventSources,

                eventRender: function eventRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    self.$emit.apply(self, ['event-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                viewRender: function viewRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    self.$emit.apply(self, ['view-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDestroy: function eventDestroy(event) {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }
                },
                eventClick: function eventClick() {
                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        args[_key3] = arguments[_key3];
                    }

                    self.$emit.apply(self, ['event-selected'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDrop: function eventDrop() {
                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        args[_key4] = arguments[_key4];
                    }

                    self.$emit.apply(self, ['event-drop'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventReceive: function eventReceive() {
                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                        args[_key5] = arguments[_key5];
                    }

                    self.$emit.apply(self, ['event-receive'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventResize: function eventResize() {
                    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                        args[_key6] = arguments[_key6];
                    }

                    self.$emit.apply(self, ['event-resize'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                dayClick: function dayClick() {
                    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                        args[_key7] = arguments[_key7];
                    }

                    self.$emit.apply(self, ['day-click'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                select: function select(start, end, jsEvent, view, resource) {
                    self.$emit('event-created', {
                        start: start,
                        end: end,
                        allDay: !start.hasTime() && !end.hasTime(),
                        view: view,
                        resource: resource
                    });
                }
            };
        }
    },

    mounted: function mounted() {
        var _this = this;

        var cal = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el),
            self = this;

        this.$on('remove-event', function (event) {
            if (event && event.hasOwnProperty('id')) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event.id);
            } else {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event);
            }
        });

        this.$on('rerender-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('rerenderEvents');
        });

        this.$on('refetch-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('refetchEvents');
        });

        this.$on('render-event', function (event) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('renderEvent', event);
        });

        this.$on('reload-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', _this.events);
        });

        this.$on('rebuild-sources', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEventSources');
            _this.eventSources.map(function (event) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', event);
            });
        });

        cal.fullCalendar(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default()(this.config, this.defaultConfig));
    },


    methods: {
        fireMethod: function fireMethod() {
            var _$;

            return (_$ = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el)).fullCalendar.apply(_$, arguments);
        }
    },

    watch: {
        events: {
            deep: true,
            handler: function handler(val) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('removeEvents');
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('addEventSource', this.events);
            }
        },
        eventSources: {
            deep: true,
            handler: function handler(val) {
                this.$emit('rebuild-sources');
            }
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.$off('remove-event');
        this.$off('rerender-events');
        this.$off('refetch-events');
        this.$off('render-event');
        this.$off('reload-events');
        this.$off('rebuild-sources');
    }
});

/***/ }),

/***/ "95s+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":50,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":50,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":50,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":50,"animation":"wave"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A3hH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PanelHeader_vue__ = __webpack_require__("dqwp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61766014_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PanelHeader_vue__ = __webpack_require__("He1F");
function injectStyle (ssrContext) {
  __webpack_require__("cAfE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61766014"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PanelHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61766014_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PanelHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AixB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BuOL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CCLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendar",attrs:{"id":"calendar"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "He1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-0"},[_c('h5',{staticClass:"page-panel-title"},[_vm._v(_vm._s(_vm.headerTitle))]),_vm._v(" "),(_vm.headerSubtitle)?_c('p',{staticClass:"page-panel-subtitle"},[_vm._v(_vm._s(_vm.headerSubtitle))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IlPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130a8e11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageFooter_vue__ = __webpack_require__("2OTX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130a8e11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KplQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":170,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":180,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":210,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":180,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":150,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":160,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":140,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":150,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":210,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":160,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":210,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":210,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":190,"height":20,"animation":"wave"}}),_vm._v(" "),_c('skeleton-loader-vue',{staticClass:"mb-4",attrs:{"width":210,"height":20,"animation":"wave"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KxxD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupComponents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_core_Toolbar_vue__ = __webpack_require__("oane");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_core_NavigationDrawer_vue__ = __webpack_require__("2Iby");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_core_Breadcrumbs_vue__ = __webpack_require__("xiKy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_core_PanelHeader_vue__ = __webpack_require__("A3hH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_core_PageFooter_vue__ = __webpack_require__("IlPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_loader_SkeletonBioLoader_vue__ = __webpack_require__("UsmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_loader_SkeletonDashboardLoader_vue__ = __webpack_require__("uPMX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_loader_SkeletonLogsLoader_vue__ = __webpack_require__("jYxR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_loader_SkeletonMenuLoader_vue__ = __webpack_require__("lqzt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_loader_SkeletonTimeLoader_vue__ = __webpack_require__("uOQ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_loader_SkeleltonChartLoader_vue__ = __webpack_require__("ye+V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_notifyjs_themes_default_scss__ = __webpack_require__("Sczw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_notifyjs_themes_default_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_notifyjs_themes_default_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sass_light_bootstrap_dashboard_scss__ = __webpack_require__("/4dZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sass_light_bootstrap_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_sass_light_bootstrap_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* eslint-disable */
/**
 * NOTE: Kani nga config para ma centralized ang mga components para usa nalang katawagan
 * og ma ready to use na bisan asa paka punta to the moon.
 */

// Core Components






//Loader Components







// asset imports







function setupComponents(Vue) {
  //Core
  Vue.component("toolbar", __WEBPACK_IMPORTED_MODULE_0__components_core_Toolbar_vue__["a" /* default */]);
  Vue.component("navigation", __WEBPACK_IMPORTED_MODULE_1__components_core_NavigationDrawer_vue__["a" /* default */]);
  Vue.component("breadcrumbs", __WEBPACK_IMPORTED_MODULE_2__components_core_Breadcrumbs_vue__["a" /* default */]);
  Vue.component("panel-header", __WEBPACK_IMPORTED_MODULE_3__components_core_PanelHeader_vue__["a" /* default */]);
  Vue.component("page-footer", __WEBPACK_IMPORTED_MODULE_4__components_core_PageFooter_vue__["a" /* default */]);
  //Loader
  Vue.component("loader-menu", __WEBPACK_IMPORTED_MODULE_5__components_loader_SkeletonBioLoader_vue__["a" /* default */]);
  Vue.component("dashboard-skeleton", __WEBPACK_IMPORTED_MODULE_6__components_loader_SkeletonDashboardLoader_vue__["a" /* default */]);
  Vue.component("dashboard-logs-loader", __WEBPACK_IMPORTED_MODULE_7__components_loader_SkeletonLogsLoader_vue__["a" /* default */]);
  Vue.component("loader-menu", __WEBPACK_IMPORTED_MODULE_8__components_loader_SkeletonMenuLoader_vue__["a" /* default */]);
  Vue.component("dashboard-timer-skeleton", __WEBPACK_IMPORTED_MODULE_9__components_loader_SkeletonTimeLoader_vue__["a" /* default */]);
  Vue.component("chart-loader", __WEBPACK_IMPORTED_MODULE_10__components_loader_SkeleltonChartLoader_vue__["a" /* default */]);
  Vue.component("card", __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_Card_vue__["a" /* default */]);
}



/***/ }),

/***/ "L/cx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticStyle:{"color":"#666","border-bottom":"1px solid #DFDFDF !important"},attrs:{"card":"","app":"","color":"#fff"}},[_c('v-toolbar-title',[_c('i',{staticClass:"fa fa-bars",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleNavigationBar($event)}}})]),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[(_vm.loader)?[_c('skeleton-loader-vue',{staticClass:"mt-3 ml-2",attrs:{"width":150,"height":28,"animation":"wave"}})]:[_c('span',{staticClass:"mt-4 account-style"},[_vm._v("\n               ESS ACCOUNT PORTAL\n          ")])]],2),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_c('span',{staticClass:"mt-4 account-style"},[(_vm.loader)?[_c('skeleton-loader-vue',{attrs:{"width":150,"height":28,"animation":"wave"}})]:[(_vm.$store.state.USER_AUTH.user.role_id === 6 )?_c('div',[_c('i',{staticClass:"fa fa-user-circle-o font-icon-user",staticStyle:{"cursor":"pointer"}}),_vm._v("   Welcome! BP Owner\n            ")]):_c('div',[_c('i',{staticClass:"fa fa-user-circle-o font-icon-user",staticStyle:{"cursor":"pointer"}}),_vm._v("   "+_vm._s(_vm._f("capitalize")(_vm.user.first_name))+" "+_vm._s(_vm._f("capitalize")(_vm.user.last_name))+"\n            ")])]],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d6c626_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Oz9g");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d6c626_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N2ME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__ = __webpack_require__("8Uc3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75db3bf7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__ = __webpack_require__("CCLi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75db3bf7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__("gJtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_global_css__ = __webpack_require__("BuOL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_employeeRequest_css__ = __webpack_require__("SLQb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_employeeRequest_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_employeeRequest_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__ = __webpack_require__("e0XP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_sweetalert__ = __webpack_require__("f1Fh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_moment__ = __webpack_require__("8AgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_dist_bootstrap_vue_esm__ = __webpack_require__("sCSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_signature_pad__ = __webpack_require__("TRHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_full_calendar__ = __webpack_require__("QaH6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_fullcalendar_dist_fullcalendar_min_css__ = __webpack_require__("AixB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_fullcalendar_dist_fullcalendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_fullcalendar_dist_fullcalendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_skeleton_loader_vue__ = __webpack_require__("mumf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__config_setup_components__ = __webpack_require__("KxxD");

/* eslint-disable */




//Vuetify














// Bootstrap Vue





// Vue Full-Calendar

// CSS Full-Calendar

// router setup


//store

//skeleton loader




/*
|----------------------------------------------------------------------
| VUE INSTANCES
|----------------------------------------------------------------------
*/

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__config_setup_components__["a" /* setupComponents */])(__WEBPACK_IMPORTED_MODULE_1_vue___default.a);

//Vuetify
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a);

//Store
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */]);

// Full calendar
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_vue_full_calendar__["a" /* default */]);
// Signature pad
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_vue_signature_pad__["a" /* default */]);
// Input Mask
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_the_mask___default.a);

// Plugin setup
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_sweetalert___default.a);

// use in routing
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

// Bootstrap vue
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_dist_bootstrap_vue_esm__["a" /* default */]);

// Form Validation
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vee_validate__["a" /* default */]);

// Vue Moment
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_vue_moment___default.a);

//Skeleton
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_22_skeleton_loader_vue__["a" /* default */]);

// // ==========================================
// // ILISI KINI SA IMONG DAA-N NGA PATCH:
// // ==========================================
// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject)
//     return originalPush.call(this, location, onResolve, onReject);
//   return originalPush.call(this, location).catch(err => {
//     // Kung NavigationDuplicated ang error, pasagdi lang (dili i-throw)
//     if (err.name === "NavigationDuplicated") {
//       return err;
//     }
//     throw err;
//   });
// };
// ==========================================
// ==========================================

/*
|----------------------------------------------------------------------
| GLOBAL SETUP
|----------------------------------------------------------------------
*/

window.axios = __webpack_require__("mtWM");
window.moment = __webpack_require__("YaIs");
window.store = __webpack_require__("Y4FN");
window.axios.defaults.baseURL = "https://endpoint.blueprintbusinesssolutionscorp.com";
// window.axios.defaults.baseURL = "http://localhost:9090";

/*
|----------------------------------------------------------------------
| CONFIGURE ROUTER
|----------------------------------------------------------------------
*/

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_20__routes_routes__["a" /* default */],
  mode: "history"
});

/*
|----------------------------------------------------------------------
|  GLOBAL TEXT & DATE FORMATING 
|----------------------------------------------------------------------
*/

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter("uppercase", function (value) {
  if (!value) return "";
  return value.toUpperCase();
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.getDate = function (date) {
  if (!date) return "N/A";
  return moment(date).format("MMM DD YYYY");
};

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.getBirth = function (date) {
  return moment(date).format("MMM DD");
};

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.leaveStartDate = function (date) {
  return moment(date).format("MMM DD");
};

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.leaveEndDate = function (date) {
  return moment(date).format("DD, YYYY");
};

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.annivDate = function (date) {
  return moment(date).format("MMM DD");
};

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.calculate = function (sum1, sum2) {
  var a = sum1 != 0.0 ? sum1 : 0;
  var b = sum2 != 0.0 ? sum2 : 0;

  var total = a + b;
  return total;
};

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.years = function (value) {
  var currentYear = new Date().getFullYear();
  var years = [];
  for (var year = value; year <= currentYear; year++) {
    years.push(year);
  }
  return years;
};

Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + h * 60 * 60 * 1000);
  return this;
};

/*
|----------------------------------------------------------------------
| ROUTER GUARD
|----------------------------------------------------------------------
*/

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (route) {
    return route.meta.requiresAuth;
  }) && !__WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */].state.USER_AUTH.isLoggedIn) {
    next({ name: "Login-Layout" });
    return;
  }
  if (to.path === "dashboard" && __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */].state.USER_AUTH.isLoggedIn) {
    next({ name: "Dashboard" });
  }

  if (to.path === "/" && __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */].state.USER_AUTH.isLoggedIn) {
    next({ name: "Dashboard" });
  }
  document.title = "ESS - " + to.name;
  next();
});

/*
|----------------------------------------------------------------------
| GLOBAL HEADER INTERCEPTORS FOR TOKEN & CORS
|----------------------------------------------------------------------
*/

axios.interceptors.request.use(function (config) {
  config.headers.common["Authorization"] = "Bearer " + localStorage.getItem("token");
  config.headers.get["Accepts"] = "application/json";
  config.headers.get["Access-Control-Allow-Origin"] = "*";
  config.headers.get["Access-Control-Allow-Methods"] = "GET,PUT,POST,DELETE,PATCH,OPTIONS";
  return config;
});

axios.interceptors.response.use(undefined, function (error) {
  if (error) {
    var originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      localStorage.removeItem("token");
      localStorage.removeItem("emp_id");
      localStorage.removeItem("role_id");
      __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */].commit("USER_AUTH/LOGOUT_USER");
      router.push("/").catch(function (err) {
        if (err.name !== "NavigationDuplicated") throw err;
      });
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
});

/*
|----------------------------------------------------------------------
| VUE INITIALIZE
|----------------------------------------------------------------------
*/

new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  el: "#app",
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App_vue__["a" /* default */]);
  },
  store: __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */],
  router: router
});

/***/ }),

/***/ "NSlq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"fixed":"","app":"","dark":""},model:{value:(_vm.toggle),callback:function ($$v) {_vm.toggle=$$v},expression:"toggle"}},[_c('v-list',[_c('div',{staticStyle:{"padding":"0px 0px 5px 20px"}},[_c('img',{attrs:{"src":"/static/img/bp_logo.png","alt":"","width":"165","height":"82"}})]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-list',[(_vm.loader_menu)?[_c('loader-menu',{staticClass:"ml-3"})]:[_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('Dashboard')}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("dashboard")])],1),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('Dashboard')}, 'item-title' ]},[_vm._v(_vm._s(('Dashboard')))])],1),_vm._v(" "),(_vm.$store.state.USER_AUTH.user.role_id === 6 )?[_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('ceoEmployeeList')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-users font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('ceoEmployeeList')}, 'item-title' ]},[_vm._v(_vm._s(('Employee List')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('ceoleaverequest')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-plane font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('ceoleaverequest')}, 'item-title' ]},[_vm._v(_vm._s(('Leave Request'))+"\n                    "),(_vm.post_request.data != '')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.post_request.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('ceoNteRequest')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-balance-scale font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('ceoNteRequest')}, 'item-title' ]},[_vm._v(_vm._s(('NTE Tracker'))+"\n                    "),(_vm.asm_nte_item.data != '')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.asm_nte_item.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('ceo-evaluation-list')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-user-circle font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('ceo-evaluation-list')}, 'item-title' ]},[_vm._v(_vm._s(('Evaluation List'))+"\n                    "),(_vm.evaluation_item_asm > 0)?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.evaluation_item_asm))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('ceoCoachingRecord')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-handshake-o font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('ceoCoachingRecord')}, 'item-title' ]},[_vm._v(_vm._s(('Employee Coaching')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('ceo-calendar')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-calendar-o font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active':_vm.isActive('ceo-calendar')}, 'item-title' ]},[_vm._v(_vm._s(('Calendar')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('ceo-time-attendance')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-clock-o font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('ceo-time-attendance')}, 'item-title' ]},[_vm._v(_vm._s(('Time & Attendance')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('settings')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-cogs font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('settings')}, 'item-title' ]},[_vm._v(_vm._s(('Settings')))])],1)]:_vm._e(),_vm._v(" "),(_vm.$store.state.USER_AUTH.user.role_id === 2)?_c('div',[_c('v-list-group',{attrs:{"prepend-icon":"supervisor_account"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',{staticClass:"item-title"},[_vm._v(_vm._s(('Members'))+"\n                    "),(_vm.post_request.data != '')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.post_request.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('members-list')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('member-list')}, 'item-title' ]},[_vm._v(_vm._s(('List')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('memberleaverequest')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('memberleaverequest')}, 'item-title' ]},[_vm._v(_vm._s(('Requests'))+"\n                    "),(_vm.post_request.data != '')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.post_request.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('nte-request')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('nte-request')}, 'item-title' ]},[_vm._v(_vm._s(('NTE Records')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('member-coaching-records')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('member-coaching-records')}, 'item-title' ]},[_vm._v(_vm._s(('Coaching Records')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('member-evaluation-list')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('member-evaluation-list')}, 'item-title' ]},[_vm._v(_vm._s(('Evaluation Records')))])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.$store.state.USER_AUTH.user.role_id === 3 )?[_c('v-list-group',{attrs:{"prepend-icon":"supervisor_account"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',{staticClass:"item-title"},[_vm._v(_vm._s(('Employee'))+"\n                       "),(_vm.post_request.data != '' || _vm.evaluation_item_asm > 0)?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.post_request.data + _vm.evaluation_item_asm + _vm.asm_nte_item.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('employee-list')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('employee-list')}, 'item-title' ]},[_vm._v(_vm._s(('List')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('employeerequest')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('employeerequest')}, 'item-title' ]},[_vm._v(_vm._s(('Requests'))+"\n                      "),(_vm.post_request.data != '')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.post_request.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('employee-nte-request')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('employee-nte-request')}, 'item-title' ]},[_vm._v(_vm._s(('NTE Records'))+"\n                      "),(_vm.asm_nte_item.data != '')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.asm_nte_item.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('employee-coaching-records')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('employee-coaching-records')}, 'item-title' ]},[_vm._v(_vm._s(('Coaching Records')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('employee-evaluation-list')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('employee-evaluation-list')}, 'item-title' ]},[_vm._v(_vm._s(('Evaluation Records'))+"\n                      "),(_vm.evaluation_item_asm > 0)?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.evaluation_item_asm))]):_vm._e()])],1)],1)]:_vm._e(),_vm._v(" "),((_vm.$store.state.USER_AUTH.user.role_id === 3) || (_vm.$store.state.USER_AUTH.user.role_id === 2) )?[_c('v-list-group',{attrs:{"prepend-icon":"perm_identity"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',{staticClass:"item-title"},[_vm._v(_vm._s(('Personal'))+"\n                        "),(_vm.coaching_item.data != '' || 
                              _vm.my_nte_item.data != '' || 
                              _vm.evaluation_item > 0 ||
                              _vm.payslip_item > 0
                              )?_c('span',{staticClass:"badge badge-danger"},[_vm._v("\n                              "+_vm._s(_vm.coaching_item.data + _vm.my_nte_item.data + _vm.evaluation_item + _vm.payslip_item)+"\n                        ")]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('Profile')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('Profile')}, 'item-title' ]},[_vm._v(_vm._s(('My Profile')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('my-coaching-records')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('my-coaching-records')}, 'item-title' ]},[_vm._v(_vm._s(('Coaching Records'))+"\n                        "),(_vm.coaching_item.data != '')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.coaching_item.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('reports')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('reports')}, 'item-title' ]},[_vm._v(_vm._s(('NTE Records'))+"\n                        "),(_vm.my_nte_item.data != '')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.my_nte_item.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('my-evaluation-list')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('my-evaluation-list')}, 'item-title' ]},[_vm._v(_vm._s(('Evaluation Records'))+"\n                        "),(_vm.evaluation_item > 0)?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.evaluation_item))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('payslip')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('payslip')}, 'item-title' ]},[_vm._v(_vm._s(('Payslip'))+"\n                        "),(_vm.payslip_item > 0)?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.payslip_item))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('my-calendar')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('my-calendar')}, 'item-title' ]},[_vm._v(_vm._s(('Calendar')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('leaverequest')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('leaverequest')}, 'item-title' ]},[_vm._v(_vm._s(('Leave')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('undertimerequest')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('undertimerequest')}, 'item-title' ]},[_vm._v(_vm._s(('Undertime')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('adjustschedule')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('adjustschedule')}, 'item-title' ]},[_vm._v(_vm._s(('Adjustment')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('responsibility-form')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('responsibility-form')}, 'item-title' ]},[_vm._v(_vm._s(('Responsibility Form')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('documents')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('documents')}, 'item-title' ]},[_vm._v(_vm._s(('Requirements Tracker')))])],1)],1)]:_vm._e(),_vm._v(" "),(_vm.$store.state.USER_AUTH.user.role_id === 1 )?[_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('Profile')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-user-o font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('Profile')}, 'item-title' ]},[_vm._v(_vm._s(('My Profile')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('my-coaching-records')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-handshake-o font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('my-coaching-records')}, 'item-title' ]},[_vm._v(_vm._s(('Coaching Records'))+"\n                    "),(_vm.coaching_item.data != '')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.coaching_item.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('reports')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-clipboard font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('reports')}, 'item-title' ]},[_vm._v(_vm._s(('NTE Records'))+"\n                    "),(_vm.my_nte_item.data != '')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.my_nte_item.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('my-evaluation-list')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-gavel font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('my-evaluation-list')}, 'item-title' ]},[_vm._v(_vm._s(('Evaluation'))+"\n                      "),(_vm.evaluation_item > 0)?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.evaluation_item))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('payslip')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-money font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('payslip')}, 'item-title' ]},[_vm._v(_vm._s(('Payslip'))+"\n                      "),(_vm.payslip_item > 0)?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.payslip_item))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('my-calendar')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-calendar font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('my-calendar')}, 'item-title' ]},[_vm._v(_vm._s(('Calendar')))])],1),_vm._v(" "),_c('v-list-group',[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('i',{staticClass:"fa fa-paper-plane-o font-icon-group"}),_vm._v(" "),_c('v-list-tile-title',{staticClass:"item-title"},[_vm._v(_vm._s(('Requests')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('leaverequest')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('leaverequest')}, 'item-title' ]},[_vm._v(_vm._s(('Leave')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('undertimerequest')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('undertimerequest')}, 'item-title' ]},[_vm._v(_vm._s(('Undertime')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('adjustschedule')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-circle-o group-list-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('adjustschedule')}, 'item-title' ]},[_vm._v(_vm._s(('Adjustment')))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('responsibility-form')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-edit font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('responsibility-form')}, 'item-title' ]},[_vm._v(_vm._s(('Responsibility Form')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('documents')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-folder-open-o font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('documents')}, 'item-title' ]},[_vm._v(_vm._s(('Requirements Tracker')))])],1)]:_vm._e(),_vm._v(" "),((_vm.$store.state.USER_AUTH.user.role_id === 1) || (_vm.$store.state.USER_AUTH.user.role_id === 3) || (_vm.$store.state.USER_AUTH.user.role_id === 2))?[_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('time-attendance')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-clock-o font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('time-attendance')}, 'item-title' ]},[_vm._v(_vm._s(('Time & Attendance')))])],1),_vm._v(" "),(_vm.$store.state.USER_AUTH.user.role_id === 3 || _vm.$store.state.USER_AUTH.user.role_id === 2)?[_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('holidays')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-calendar-check-o font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('holidays')}, 'item-title' ]},[_vm._v(_vm._s(('Holidays')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('workschedule')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-calendar-plus-o font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('workschedule')}, 'item-title' ]},[_vm._v(_vm._s(('Work Schedule')))])],1)]:_vm._e(),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('contracts-memo')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-newspaper-o font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('contracts-memo')}, 'item-title' ]},[_vm._v(_vm._s(('Contracts & Memos'))+"\n                      "),(_vm.my_contract_memo_item.data != '')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.my_contract_memo_item.data))]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.changeRoute('settings')}}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-cogs font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{class:[{'active': _vm.isActive('settings')}, 'item-title' ]},[_vm._v(_vm._s(('Settings')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.logoutAction}},[_c('v-list-tile-action',[_c('i',{staticClass:"fa fa-sign-out font-icon"})]),_vm._v(" "),_c('v-list-tile-title',{staticClass:"item-title"},[_vm._v("\n                      "+_vm._s(('Logout'))+"\n                    ")])],1)]:_vm._e()]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NnJV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Oz9g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QDyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card'
});

/***/ }),

/***/ "Rr+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */

var notification = {
  namespaced: true,
  state: {
    my_nte_item: [],
    asm_nte_item: [],
    coaching_item: [],
    post_request: [],
    evaluation_item: [],
    evaluation_item_asm: [],
    my_contract_memo_item: [],
    payslip_item: 0
  },
  getters: {},
  actions: {
    LOAD_PAYSLIP: function LOAD_PAYSLIP(_ref) {
      var commit = _ref.commit;

      axios.get("api/payslip/unread/count").then(function (resp) {
        var payslip_item = Number(resp.data);
        console.log("payslip count=>", payslip_item);
        commit("SET_PAYSLIP", payslip_item);
      }).catch(function (error) {
        console.log(error);
      });
    },
    LOAD_EVALUATION: function LOAD_EVALUATION(_ref2) {
      var commit = _ref2.commit;

      axios.get("api/evaluation/counter").then(function (resp) {
        var evaluation_item = resp.data;
        commit("SET_EVALUATION", evaluation_item);
      }).catch(function (error) {
        console.log(error);
      });
    },
    LOAD_EVALUATION_ASM: function LOAD_EVALUATION_ASM(_ref3) {
      var commit = _ref3.commit;

      axios.get("api/evaluation/counter/get/asm").then(function (resp) {
        var evaluation_item_asm = resp.data;
        commit("SET_EVALUATION_ASM", evaluation_item_asm);
      }).catch(function (error) {
        console.log(error);
      });
    },
    LOAD_REQUEST: function LOAD_REQUEST(_ref4) {
      var commit = _ref4.commit;

      axios.get("api/notification/counter").then(function (resp) {
        var post_request = resp.data;
        commit("SET_POSTS", post_request);
      }).catch(function (error) {
        console.log(error);
      });
    },
    NTE_NOTIFY_ME: function NTE_NOTIFY_ME(_ref5) {
      var commit = _ref5.commit;

      axios.get("api/notifyme/nte/counter").then(function (resp) {
        var my_nte_item = resp.data;
        commit("SET_NTE_NOTIFY_ME", my_nte_item);
      }).catch(function (error) {
        console.log(error);
      });
    },
    NTE_NOTIFY_ASM: function NTE_NOTIFY_ASM(_ref6) {
      var commit = _ref6.commit;

      axios.get("api/notifynte/counter").then(function (resp) {
        var asm_nte_item = resp.data;
        commit("SET_NTE_NOTIFY_ASM", asm_nte_item);
      }).catch(function (error) {
        console.log(error);
      });
    },
    COACHING_COUNTER: function COACHING_COUNTER(_ref7) {
      var commit = _ref7.commit;

      axios.get("api/coaching/counter").then(function (resp) {
        var coaching_item = resp.data;
        commit("SET_COACHING_NOTIFY", coaching_item);
      }).catch(function (error) {
        console.log(error);
      });
    },
    CONTRACT_MEMO_NOTIFY_ME: function CONTRACT_MEMO_NOTIFY_ME(_ref8) {
      var commit = _ref8.commit;

      axios.get("api/notifyme/contractmemo/counter").then(function (resp) {
        var my_contract_memo_item = resp.data;
        commit("SET_CONTRACT_MEMO_NOTIFY_ME", my_contract_memo_item);
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mutations: {
    //PAYSLIP NOTIFICATION COUNTER ALL
    SET_PAYSLIP: function SET_PAYSLIP(state, payslip_item) {
      state.payslip_item = payslip_item;
    },


    //EVALUATION NOTIFICATION COUNTER ALL
    SET_EVALUATION: function SET_EVALUATION(state, evaluation_item) {
      state.evaluation_item = evaluation_item;
    },


    //EVALUATION NOTIFICATION COUNTER ASM
    SET_EVALUATION_ASM: function SET_EVALUATION_ASM(state, evaluation_item_asm) {
      state.evaluation_item_asm = evaluation_item_asm;
    },


    //POST FOR NOTIFICATION
    SET_POSTS: function SET_POSTS(state, post_request) {
      state.post_request = post_request;
    },


    //NOTIFY MY NTE TRACKER
    SET_COACHING_NOTIFY: function SET_COACHING_NOTIFY(state, coaching_item) {
      state.coaching_item = coaching_item;
    },


    //NOTIFY MY NTE TRACKER
    SET_NTE_NOTIFY_ME: function SET_NTE_NOTIFY_ME(state, my_nte_item) {
      state.my_nte_item = my_nte_item;
    },


    //NOTIFY ASM NTE TRACKER
    SET_NTE_NOTIFY_ASM: function SET_NTE_NOTIFY_ASM(state, asm_nte_item) {
      state.asm_nte_item = asm_nte_item;
    },


    //NOTIFY CONTRACT/MEMO TRACKER
    SET_CONTRACT_MEMO_NOTIFY_ME: function SET_CONTRACT_MEMO_NOTIFY_ME(state, my_contract_memo_item) {
      state.my_contract_memo_item = my_contract_memo_item;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (notification);

/***/ }),

/***/ "SLQb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sczw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
var routes = [
// LOGIN FORM
{
  path: "/",
  name: "Login-Layout",
  component: function component() {
    return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, "Eb6U"));
  },
  meta: {
    allowAnonymous: true
  }
},
//MAIN APP
{
  path: "/",
  component: function component() {
    return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, "MnrW"));
  },
  meta: { requiresAuth: true },
  children: [
  // Page Routes
  {
    path: "/dashboard",
    name: "Dashboard",
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "KQwK"));
    },
    meta: {
      breadcrumb: [{ name: "Dashboard" }],
      requiresAuth: true
    }
  }, {
    path: "/company-chart",
    name: "CompanyChart",
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "GPQC"));
    },
    meta: {
      breadcrumb: [{ name: "CompanyChart" }],
      requiresAuth: true
    }
  },
  //route for profile
  {
    path: "/profile",
    name: "Profile",
    component: function component() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "D8Pc"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //CEO Pages
  {
    path: "/timeattendance",
    name: "ceo-time-attendance",
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "ivdO"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceocalendar",
    name: "ceo-calendar",
    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "edMz"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceoemployeelist",
    name: "ceoEmployeeList",
    component: function component() {
      return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, "QsI/"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceoemployeeprofile/:id",
    name: "ceo-employee-profile",
    component: function component() {
      return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, "7ZKr"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceovaluationlist",
    name: "ceo-evaluation-list",
    component: function component() {
      return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, "1FJp"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceovaluationdetails/:id/:employee_id",
    name: "ceo-evaluation-details",
    component: function component() {
      return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, "e0i+"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceovaluationreview/:id/:employee_id",
    name: "ceo-evaluation-review",
    component: function component() {
      return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, "9Anx"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceoleaverequest",
    name: "ceoleaverequest",
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "yLkz"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceoapproveleave/:id",
    name: "ceoApproveLeave",
    component: function component() {
      return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, "Nsnu"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceonterequest",
    name: "ceoNteRequest",
    component: function component() {
      return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, "XYMS"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceocoachingtecord",
    name: "ceoCoachingRecord",
    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "Ss8e"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/nteViewTracker/:id/:employeeId",
    name: "ceo-view-nte-tracker",
    component: function component() {
      return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, "zKLL"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceoNteApproval/:id/:employeeId",
    name: "ceo-nte-approval",
    component: function component() {
      return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, "CewN"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/ceoCoachingDetails/:coachId",
    name: "ceo-coaching-details",
    component: function component() {
      return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, "VEye"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for Employee Request
  {
    path: "/employeerequest",
    name: "employeerequest",
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "mm5S"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employeeleavedetails/:id",
    name: "employee-leave-details",
    component: function component() {
      return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, "TFeP"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/editemployeerequest/:id",
    name: "editemployeerequest",
    component: function component() {
      return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, "JU5i"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employeescheduleadjustment",
    name: "employee-schedule-adjustment",
    component: function component() {
      return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, "xpO3"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/EmployeeEditScheduleAdjustment",
    name: "employee-edit-schedule-adjustment",
    component: function component() {
      return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, "EgLV"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employeeundertimerequest",
    name: "employee-undertime-request",
    component: function component() {
      return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, "gbDN"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employeeeditundertimerequest",
    name: "employee-edit-undertime-request",
    component: function component() {
      return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, "z0DL"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //Members List
  {
    path: "/memberslist",
    name: "members-list",
    component: function component() {
      return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "peyd"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/membersprofile/:id",
    name: "members-view-profile",
    component: function component() {
      return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "D+A5"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //Employee List
  {
    path: "/employeelist",
    name: "employee-list",
    component: function component() {
      return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, "HCwf"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employeeprofile/:id",
    name: "employee-view-profile",
    component: function component() {
      return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, "HEDS"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for member request
  {
    path: "/memberleavedetails/:id",
    name: "member-leave-details",
    component: function component() {
      return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, "My1a"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/memberleaverequest",
    name: "memberleaverequest",
    component: function component() {
      return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, "IweH"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/editmemberleaverequest/:id",
    name: "editmemberleaverequest",
    component: function component() {
      return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, "lw8b"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/memberundertimerequest",
    name: "member-undertime-request",
    component: function component() {
      return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, "9flc"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/membereditundertimerequest",
    name: "member-edit-undertime-request",
    component: function component() {
      return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, "hUlf"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/memberdscheduleadjustmentrequest",
    name: "member-schedule-adjustment-request",
    component: function component() {
      return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, "sMMN"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/membereditscheduleadjustmentrequest",
    name: "member-edit-schedule-adjustment-request",
    component: function component() {
      return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, "EJiI"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for reminders
  {
    path: "/reminders",
    name: "reminders",
    component: function component() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "vLNO"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for leave request
  {
    path: "/leaverequest",
    name: "leaverequest",
    component: function component() {
      return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "InsB"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/newleaverequest",
    name: "newleaverequest",
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "DhdZ"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/updaterequest",
    name: "updaterequest",
    component: function component() {
      return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "W047"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/viewrequest",
    name: "viewrequest",
    component: function component() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "lXbr"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for undertime request
  {
    path: "/undertimerequest",
    name: "undertimerequest",
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "Esdo"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/newundertimerequest",
    name: "newundertimerequest",
    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "cQME"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/editundertimerequest",
    name: "edit-under-time-request",
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "vGTf"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for adjust schedule
  {
    path: "/adjustschedule",
    name: "adjustschedule",
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "mg0B"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/editadjustschedule",
    name: "edit-adjust-schedule",
    component: function component() {
      return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "m7hC"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/newadjustschedule",
    name: "newadjustschedule",
    component: function component() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "knYQ"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for NTE Request - TL SIDE
  {
    path: "/nterequest",
    name: "nte-request",
    component: function component() {
      return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, "F++b"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/nterequestform",
    name: "nte-request-form",
    component: function component() {
      return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, "y6NP"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/editnterequestform/:id/:employee_id",
    name: "edit-nte-request-form",
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "wXwE"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/nteviewrequestdetails/:id/:employee_id",
    name: "nte-view-request-details",
    component: function component() {
      return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, "+yDm"));
    },
    meta: {
      requiresAuth: true
    }
  },
  // Coaching Module BY ASM
  {
    path: "/employee/coaching/records",
    name: "employee-coaching-records",
    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "/BPP"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employee/coaching/form",
    name: "employee-coaching-form",
    component: function component() {
      return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, "3vax"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employee/coaching/update/:id",
    name: "employee-coaching-update",
    component: function component() {
      return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, "KJOZ"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employee/coaching/details/:id/:uuid",
    name: "employee-coaching-details",
    component: function component() {
      return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, "oGuN"));
    },
    meta: {
      requiresAuth: true
    }
  },
  // Coaching Module BY TL
  {
    path: "/member/coaching/records",
    name: "member-coaching-records",
    component: function component() {
      return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, "iNuM"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/member/coachingform",
    name: "member-coaching-form",
    component: function component() {
      return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, "zQug"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/member/coaching/update/:id",
    name: "member-coaching-update",
    component: function component() {
      return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, "d8yH"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/member/coaching/details/:id",
    name: "member-coaching-details",
    component: function component() {
      return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, "fU7h"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //My Performance Evaluation AGENT SIDE
  {
    path: "/my/evaluation/list",
    name: "my-evaluation-list",
    component: function component() {
      return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, "MMwy"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/my/evaluation/review/:id",
    name: "my-evaluation-review",
    component: function component() {
      return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, "ikVV"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/my/evaluation/details/:id",
    name: "view-evaluation-details",
    component: function component() {
      return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, "mEyY"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //Members Performance Evaluation -TL SIDE
  {
    path: "/members/evaluation/list",
    name: "member-evaluation-list",
    component: function component() {
      return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, "mcTd"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/members/evaluation/details/:id/:employee_id",
    name: "member-evaluation-details",
    component: function component() {
      return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, "s3uD"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/members/evaluation/form",
    name: "member-evaluation-form",
    component: function component() {
      return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, "13ih"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/members/evaluation/update/:id/:employee_id",
    name: "member-evaluation-update",
    component: function component() {
      return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, "epoK"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //Employees Performance Evaluation -AM SIDE
  {
    path: "/employee/evaluation/list",
    name: "employee-evaluation-list",
    component: function component() {
      return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, "Y2rK"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employee/evaluation/details/:id/:employee_id",
    name: "employee-evaluation-details",
    component: function component() {
      return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, "powp"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employee/evaluation/form",
    name: "employee-evaluation-form",
    component: function component() {
      return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, "HDEs"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employee/evaluation/update/:id/:employee_id",
    name: "employee-evaluation-update",
    component: function component() {
      return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, "Vh5T"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employee/evaluation/review/:id/:employee_id",
    name: "employee-evaluation-review",
    component: function component() {
      return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, "qtWo"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //Coaching Module BY Member
  {
    path: "/my/coaching/records",
    name: "my-coaching-records",
    component: function component() {
      return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, "9m+D"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/my/commitment/form/:id",
    name: "my-commitment-form",
    component: function component() {
      return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, "4Qew"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/my/coaching/details/:id",
    name: "my-coaching-details",
    component: function component() {
      return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, "tAnA"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/my/coaching/update/:id",
    name: "my-coaching-update",
    component: function component() {
      return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, "GGkE"));
    },
    meta: {
      requiresAuth: true
    }
  },
  // Route for NTE Request - ASM Side
  {
    path: "/employeenterequest",
    name: "employee-nte-request",
    component: function component() {
      return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, "Hnel"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employeenterequestform",
    name: "employee-nte-request-form",
    component: function component() {
      return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, "N+Lp"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employeeeditnterequestform/:id/:employee_id",
    name: "employee-edit-nte-request",
    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "FMkD"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employeenteapproval/:id/:employee_id",
    name: "employee-nte-approval",
    component: function component() {
      return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, "uLUZ"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/employeenteviewrequest/:id/:employee_id",
    name: "employee-nte-view-request",
    component: function component() {
      return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, "FIXx"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for responsibility form
  {
    path: "/responsibilityform",
    name: "responsibility-form",
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "Di4C"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/wfh/responsibility/form",
    name: "wfh-responsibility-form",
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "do9p"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for documents
  {
    path: "/documents",
    name: "documents",
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "yAAZ"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/calendar",
    name: "calendar",
    component: function component() {
      return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, "sjwQ"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/holidays",
    name: "holidays",
    component: function component() {
      return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, "vuk6"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/workschedule",
    name: "workschedule",
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "qnNA"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/addworkshift",
    name: "workshift",
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "8ZGX"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/addrestday",
    name: "restday",
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "rthA"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/addcalendarevent",
    name: "add-calendar-event",
    component: function component() {
      return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, "P1tA"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for time & attendance
  {
    path: "/timeattendance",
    name: "time-attendance",
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "UvED"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/editattendance/:id",
    name: "edit-attendance",
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "OU4Z"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for contracts memo
  {
    path: "/contractsmemo",
    name: "contracts-memo",
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "7S79"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for assigning contracts
  {
    path: "/contracts/assign/:id",
    name: "assign-contracts",
    component: function component() {
      return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, "diOU"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for assigning memos
  {
    path: "/memos/assign/:id",
    name: "assign-memos",
    component: function component() {
      return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, "hlEi"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for announcement
  {
    path: "/announcements",
    name: "announcements",
    component: function component() {
      return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, "2IZJ"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for birthday event
  {
    path: "/mycalendar",
    name: "my-calendar",
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "BR4h"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for calendar event
  {
    path: "/calendarEvent",
    name: "calendar-event",
    component: function component() {
      return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, "yIia"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for attendance
  {
    path: "/attendance",
    name: "attendance",
    component: function component() {
      return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, "dFOL"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for reports
  {
    path: "/reports",
    name: "reports",
    component: function component() {
      return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "YgNv"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/updatereport",
    name: "update-report",
    component: function component() {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "Efyb"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/viewreport",
    name: "view-report",
    component: function component() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "cWnT"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for payslip
  {
    path: "/payslip",
    name: "payslip",
    component: function component() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "JFcz"));
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/viewpayslip/:uuid",
    name: "view-payslip",
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "2w2J"));
    },
    meta: {
      requiresAuth: true
    }
  },
  //route for apply loan
  {
    path: "/applyloan",
    name: "applyloan",
    component: function component() {
      return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, "abQp"));
    },
    meta: {
      requiresAuth: true
    }
  },
  // route for change password
  {
    path: "/settings",
    name: "settings",
    component: function component() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "GutM"));
    },
    meta: {
      requiresAuth: true
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "UsmL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38da1cdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeletonBioLoader_vue__ = __webpack_require__("95s+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38da1cdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeletonBioLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "baav":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":140,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":140,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":140,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":365,"height":140,"animation":"wave"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bmA6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var _this = this;

/* eslint-disable */


var dashboard = {
    namespaced: true,
    state: {
        aniversary: [],
        aniversaryAll: [],
        absents: [],
        birthdayAll: [],
        birthday: [],
        employeeLeave: [],
        leaveCredits: [],
        leaveRefresh: []
    },
    getters: {},
    actions: {
        GET_LEAVE_REFRESH: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
                var commit = _ref2.commit;

                var _ref3, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/leaveRefresh');

                            case 2:
                                _ref3 = _context.sent;
                                data = _ref3.data;

                                commit('SET_LEAVE_REFRESH', data);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function GET_LEAVE_REFRESH(_x) {
                return _ref.apply(this, arguments);
            };
        }(),

        GET_ANNIVERSARRY_ALL: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5) {
                var commit = _ref5.commit;

                var _ref6, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/anniversary/all');

                            case 2:
                                _ref6 = _context2.sent;
                                data = _ref6.data;

                                commit('SET_ANNIVERSARRY_ALL', data);

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }));

            return function GET_ANNIVERSARRY_ALL(_x2) {
                return _ref4.apply(this, arguments);
            };
        }(),

        GET_ANNIVERSARRY: function () {
            var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8) {
                var commit = _ref8.commit;

                var _ref9, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/anniversary');

                            case 2:
                                _ref9 = _context3.sent;
                                data = _ref9.data;

                                commit('SET_ANNIVERSARRY', data);

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this);
            }));

            return function GET_ANNIVERSARRY(_x3) {
                return _ref7.apply(this, arguments);
            };
        }(),

        GET_ABSENTS: function () {
            var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref11) {
                var commit = _ref11.commit;

                var _ref12, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/countAbsent');

                            case 2:
                                _ref12 = _context4.sent;
                                data = _ref12.data;

                                commit('SET_ABSENTS', data);

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this);
            }));

            return function GET_ABSENTS(_x4) {
                return _ref10.apply(this, arguments);
            };
        }(),

        GET_EMPLOYEE_BIRTHDAY: function () {
            var _ref13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref14) {
                var commit = _ref14.commit;

                var _ref15, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/celebrant');

                            case 2:
                                _ref15 = _context5.sent;
                                data = _ref15.data;

                                commit('SET_EMPLOYEE_BIRTHDAY', data);

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this);
            }));

            return function GET_EMPLOYEE_BIRTHDAY(_x5) {
                return _ref13.apply(this, arguments);
            };
        }(),

        GET_BIRTHDAY: function () {
            var _ref16 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref17) {
                var commit = _ref17.commit;

                var _ref18, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/birthday');

                            case 2:
                                _ref18 = _context6.sent;
                                data = _ref18.data;

                                commit('SET_BIRTHDAY', data);

                            case 5:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this);
            }));

            return function GET_BIRTHDAY(_x6) {
                return _ref16.apply(this, arguments);
            };
        }(),

        GET_EMPLOYEE_LEAVE: function () {
            var _ref19 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_ref20) {
                var commit = _ref20.commit;

                var _ref21, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/employee/leave');

                            case 2:
                                _ref21 = _context7.sent;
                                data = _ref21.data;

                                commit('SET_EMPLOYEE_LEAVE', data);

                            case 5:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this);
            }));

            return function GET_EMPLOYEE_LEAVE(_x7) {
                return _ref19.apply(this, arguments);
            };
        }(),

        GET_LEAVE_CREDITS: function () {
            var _ref22 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(_ref23) {
                var commit = _ref23.commit;

                var _ref24, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/credits');

                            case 2:
                                _ref24 = _context8.sent;
                                data = _ref24.data;

                                commit('SET_LEAVE_CREDITS', data);

                            case 5:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this);
            }));

            return function GET_LEAVE_CREDITS(_x8) {
                return _ref22.apply(this, arguments);
            };
        }()
    },
    mutations: {
        SET_LEAVE_REFRESH: function SET_LEAVE_REFRESH(state, payload) {
            state.leaveRefresh = payload;
        },

        SET_ANNIVERSARRY_ALL: function SET_ANNIVERSARRY_ALL(state, payload) {
            state.aniversaryAll = payload;
        },

        SET_ANNIVERSARRY: function SET_ANNIVERSARRY(state, payload) {
            state.aniversary = payload;
        },

        SET_ABSENTS: function SET_ABSENTS(state, payload) {
            state.absents = payload;
        },

        SET_EMPLOYEE_BIRTHDAY: function SET_EMPLOYEE_BIRTHDAY(state, payload) {
            state.birthdayAll = payload;
        },

        SET_BIRTHDAY: function SET_BIRTHDAY(state, payload) {
            state.birthday = payload;
        },

        SET_EMPLOYEE_LEAVE: function SET_EMPLOYEE_LEAVE(state, payload) {
            state.employeeLeave = payload;
        },

        SET_LEAVE_CREDITS: function SET_LEAVE_CREDITS(state, payload) {
            state.leaveCredits = payload;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (dashboard);

/***/ }),

/***/ "cAfE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dqwp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PanelHeader',
  computed: {
    headerTitle: function headerTitle() {
      return this.$route.meta.title || '';
    },
    headerSubtitle: function headerSubtitle() {
      return this.$route.meta.sub_title || '';
    }
  }
});

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fiA2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gJtD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jEp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("QDyf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e82cef80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("xLkP");
function injectStyle (ssrContext) {
  __webpack_require__("fiA2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e82cef80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jYxR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5184ee49_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeletonLogsLoader_vue__ = __webpack_require__("kw2r");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5184ee49_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeletonLogsLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kBR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */

function Point(x, y, time) {
  this.x = x;
  this.y = y;
  this.time = time || new Date().getTime();
}

Point.prototype.velocityFrom = function (start) {
  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};

Point.prototype.distanceTo = function (start) {
  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};

Point.prototype.equals = function (other) {
  return this.x === other.x && this.y === other.y && this.time === other.time;
};

function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function () {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

/* eslint-disable no-multi-spaces, space-in-parens */
Bezier.prototype._point = function (t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

/* eslint-disable */

// http://stackoverflow.com/a/27078401/815507
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function SignaturePad(canvas, options) {
  var self = this;
  var opts = options || {};

  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
  this.minWidth = opts.minWidth || 0.5;
  this.maxWidth = opts.maxWidth || 2.5;
  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

  if (this.throttle) {
    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
  } else {
    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
  }

  this.dotSize = opts.dotSize || function () {
    return (this.minWidth + this.maxWidth) / 2;
  };
  this.penColor = opts.penColor || 'black';
  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
  this.onBegin = opts.onBegin;
  this.onEnd = opts.onEnd;

  this._canvas = canvas;
  this._ctx = canvas.getContext('2d');
  this.clear();

  // We need add these inline so they are available to unbind while still having
  // access to 'self' we could use _.bind but it's not worth adding a dependency.
  this._handleMouseDown = function (event) {
    if (event.which === 1) {
      self._mouseButtonDown = true;
      self._strokeBegin(event);
    }
  };

  this._handleMouseMove = function (event) {
    if (self._mouseButtonDown) {
      self._strokeMoveUpdate(event);
    }
  };

  this._handleMouseUp = function (event) {
    if (event.which === 1 && self._mouseButtonDown) {
      self._mouseButtonDown = false;
      self._strokeEnd(event);
    }
  };

  this._handleTouchStart = function (event) {
    if (event.targetTouches.length === 1) {
      var touch = event.changedTouches[0];
      self._strokeBegin(touch);
    }
  };

  this._handleTouchMove = function (event) {
    // Prevent scrolling.
    event.preventDefault();

    var touch = event.targetTouches[0];
    self._strokeMoveUpdate(touch);
  };

  this._handleTouchEnd = function (event) {
    var wasCanvasTouched = event.target === self._canvas;
    if (wasCanvasTouched) {
      event.preventDefault();
      self._strokeEnd(event);
    }
  };

  // Enable mouse and touch event handlers
  this.on();
}

// Public methods
SignaturePad.prototype.clear = function () {
  var ctx = this._ctx;
  var canvas = this._canvas;

  ctx.fillStyle = this.backgroundColor;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  this._data = [];
  this._reset();
  this._isEmpty = true;
};

SignaturePad.prototype.fromDataURL = function (dataUrl) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var image = new Image();
  var ratio = options.ratio || window.devicePixelRatio || 1;
  var width = options.width || this._canvas.width / ratio;
  var height = options.height || this._canvas.height / ratio;

  this._reset();
  image.src = dataUrl;
  image.onload = function () {
    _this._ctx.drawImage(image, 0, 0, width, height);
  };
  this._isEmpty = false;
};

SignaturePad.prototype.toDataURL = function (type) {
  var _canvas;

  switch (type) {
    case 'image/svg+xml':
      return this._toSVG();
    default:
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
  }
};

SignaturePad.prototype.on = function () {
  this._handleMouseEvents();
  this._handleTouchEvents();
};

SignaturePad.prototype.off = function () {
  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
  document.removeEventListener('mouseup', this._handleMouseUp);

  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype.isEmpty = function () {
  return this._isEmpty;
};

// Private methods
SignaturePad.prototype._strokeBegin = function (event) {
  this._data.push([]);
  this._reset();
  this._strokeUpdate(event);

  if (typeof this.onBegin === 'function') {
    this.onBegin(event);
  }
};

SignaturePad.prototype._strokeUpdate = function (event) {
  var x = event.clientX;
  var y = event.clientY;

  var point = this._createPoint(x, y);
  var lastPointGroup = this._data[this._data.length - 1];
  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;

  // Skip this point if it's too close to the previous one
  if (!(lastPoint && isLastPointTooClose)) {
    var _addPoint = this._addPoint(point),
        curve = _addPoint.curve,
        widths = _addPoint.widths;

    if (curve && widths) {
      this._drawCurve(curve, widths.start, widths.end);
    }

    this._data[this._data.length - 1].push({
      x: point.x,
      y: point.y,
      time: point.time,
      color: this.penColor
    });
  }
};

SignaturePad.prototype._strokeEnd = function (event) {
  var canDrawCurve = this.points.length > 2;
  var point = this.points[0]; // Point instance

  if (!canDrawCurve && point) {
    this._drawDot(point);
  }

  if (point) {
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object

    // When drawing a dot, there's only one point in a group, so without this check
    // such group would end up with exactly the same 2 points.
    if (!point.equals(lastPoint)) {
      lastPointGroup.push({
        x: point.x,
        y: point.y,
        time: point.time,
        color: this.penColor
      });
    }
  }

  if (typeof this.onEnd === 'function') {
    this.onEnd(event);
  }
};

SignaturePad.prototype._handleMouseEvents = function () {
  this._mouseButtonDown = false;

  this._canvas.addEventListener('mousedown', this._handleMouseDown);
  this._canvas.addEventListener('mousemove', this._handleMouseMove);
  document.addEventListener('mouseup', this._handleMouseUp);
};

SignaturePad.prototype._handleTouchEvents = function () {
  // Pass touch events to canvas element on mobile IE11 and Edge.
  this._canvas.style.msTouchAction = 'none';
  this._canvas.style.touchAction = 'none';

  this._canvas.addEventListener('touchstart', this._handleTouchStart);
  this._canvas.addEventListener('touchmove', this._handleTouchMove);
  this._canvas.addEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype._reset = function () {
  this.points = [];
  this._lastVelocity = 0;
  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
  this._ctx.fillStyle = this.penColor;
};

SignaturePad.prototype._createPoint = function (x, y, time) {
  var rect = this._canvas.getBoundingClientRect();

  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
};

SignaturePad.prototype._addPoint = function (point) {
  var points = this.points;
  var tmp = void 0;

  points.push(point);

  if (points.length > 2) {
    // To reduce the initial lag make it work with 3 points
    // by copying the first point to the beginning.
    if (points.length === 3) points.unshift(points[0]);

    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
    var c2 = tmp.c2;
    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
    var c3 = tmp.c1;
    var curve = new Bezier(points[1], c2, c3, points[2]);
    var widths = this._calculateCurveWidths(curve);

    // Remove the first element from the list,
    // so that we always have no more than 4 points in points array.
    points.shift();

    return { curve: curve, widths: widths };
  }

  return {};
};

SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
  var dx1 = s1.x - s2.x;
  var dy1 = s1.y - s2.y;
  var dx2 = s2.x - s3.x;
  var dy2 = s2.y - s3.y;

  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

  var dxm = m1.x - m2.x;
  var dym = m1.y - m2.y;

  var k = l2 / (l1 + l2);
  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

  var tx = s2.x - cm.x;
  var ty = s2.y - cm.y;

  return {
    c1: new Point(m1.x + tx, m1.y + ty),
    c2: new Point(m2.x + tx, m2.y + ty)
  };
};

SignaturePad.prototype._calculateCurveWidths = function (curve) {
  var startPoint = curve.startPoint;
  var endPoint = curve.endPoint;
  var widths = { start: null, end: null };

  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

  var newWidth = this._strokeWidth(velocity);

  widths.start = this._lastWidth;
  widths.end = newWidth;

  this._lastVelocity = velocity;
  this._lastWidth = newWidth;

  return widths;
};

SignaturePad.prototype._strokeWidth = function (velocity) {
  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};

SignaturePad.prototype._drawPoint = function (x, y, size) {
  var ctx = this._ctx;

  ctx.moveTo(x, y);
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  this._isEmpty = false;
};

SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
  var ctx = this._ctx;
  var widthDelta = endWidth - startWidth;
  var drawSteps = Math.floor(curve.length());

  ctx.beginPath();

  for (var i = 0; i < drawSteps; i += 1) {
    // Calculate the Bezier (x, y) coordinate for this step.
    var t = i / drawSteps;
    var tt = t * t;
    var ttt = tt * t;
    var u = 1 - t;
    var uu = u * u;
    var uuu = uu * u;

    var x = uuu * curve.startPoint.x;
    x += 3 * uu * t * curve.control1.x;
    x += 3 * u * tt * curve.control2.x;
    x += ttt * curve.endPoint.x;

    var y = uuu * curve.startPoint.y;
    y += 3 * uu * t * curve.control1.y;
    y += 3 * u * tt * curve.control2.y;
    y += ttt * curve.endPoint.y;

    var width = startWidth + ttt * widthDelta;
    this._drawPoint(x, y, width);
  }

  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._drawDot = function (point) {
  var ctx = this._ctx;
  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;

  ctx.beginPath();
  this._drawPoint(point.x, point.y, width);
  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
  for (var i = 0; i < pointGroups.length; i += 1) {
    var group = pointGroups[i];

    if (group.length > 1) {
      for (var j = 0; j < group.length; j += 1) {
        var rawPoint = group[j];
        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
        var color = rawPoint.color;

        if (j === 0) {
          // First point in a group. Nothing to draw yet.

          // All points in the group have the same color, so it's enough to set
          // penColor just at the beginning.
          this.penColor = color;
          this._reset();

          this._addPoint(point);
        } else if (j !== group.length - 1) {
          // Middle point in a group.
          var _addPoint2 = this._addPoint(point),
              curve = _addPoint2.curve,
              widths = _addPoint2.widths;

          if (curve && widths) {
            drawCurve(curve, widths, color);
          }
        } else {
          // Last point in a group. Do nothing.
        }
      }
    } else {
      this._reset();
      var _rawPoint = group[0];
      drawDot(_rawPoint);
    }
  }
};

SignaturePad.prototype._toSVG = function () {
  var _this2 = this;

  var pointGroups = this._data;
  var canvas = this._canvas;
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  var minX = 0;
  var minY = 0;
  var maxX = canvas.width / ratio;
  var maxY = canvas.height / ratio;
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttributeNS(null, 'width', canvas.width);
  svg.setAttributeNS(null, 'height', canvas.height);

  this._fromData(pointGroups, function (curve, widths, color) {
    var path = document.createElement('path');

    // Need to check curve for NaN values, these pop up when drawing
    // lines on the canvas that are not continuous. E.g. Sharp corners
    // or stopping mid-stroke and than continuing without lifting mouse.
    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));

      path.setAttribute('d', attr);
      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
      path.setAttribute('stroke', color);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke-linecap', 'round');

      svg.appendChild(path);
    }
  }, function (rawPoint) {
    var circle = document.createElement('circle');
    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
    circle.setAttribute('r', dotSize);
    circle.setAttribute('cx', rawPoint.x);
    circle.setAttribute('cy', rawPoint.y);
    circle.setAttribute('fill', rawPoint.color);

    svg.appendChild(circle);
  });

  var prefix = 'data:image/svg+xml;base64,';
  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
  var body = svg.innerHTML;

  // IE hack for missing innerHTML property on SVGElement
  if (body === undefined) {
    var dummy = document.createElement('dummy');
    var nodes = svg.childNodes;
    dummy.innerHTML = '';

    for (var i = 0; i < nodes.length; i += 1) {
      dummy.appendChild(nodes[i].cloneNode(true));
    }

    body = dummy.innerHTML;
  }

  var footer = '</svg>';
  var data = header + body + footer;

  return prefix + btoa(data);
};

SignaturePad.prototype.fromData = function (pointGroups) {
  var _this3 = this;

  this.clear();

  this._fromData(pointGroups, function (curve, widths) {
    return _this3._drawCurve(curve, widths.start, widths.end);
  }, function (rawPoint) {
    return _this3._drawDot(rawPoint);
  });

  this._data = pointGroups;
};

SignaturePad.prototype.toData = function () {
  return this._data;
};

/* harmony default export */ __webpack_exports__["a"] = (SignaturePad);


/***/ }),

/***/ "kw2r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"card card-stats"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-md-2"},[_c('skeleton-loader-vue',{staticClass:"mb-3",attrs:{"width":100,"height":20,"animation":"wave"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_vm._v("\n                    Time Logs for "+_vm._s(new Date().toLocaleDateString())+"\n                ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lqzt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7954c36e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeletonMenuLoader_vue__ = __webpack_require__("KplQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7954c36e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeletonMenuLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oane":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__ = __webpack_require__("3qaA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438b1866_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__ = __webpack_require__("L/cx");
function injectStyle (ssrContext) {
  __webpack_require__("wjG+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438b1866_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_userDashboard_js__ = __webpack_require__("bmA6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_authentication_js__ = __webpack_require__("4ZQf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_userNotification_js__ = __webpack_require__("Rr+e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_userProfile_js__ = __webpack_require__("pBDz");
/* eslint-disable */










__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */], __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
   //strict: true,
   modules: {
      DASHBOARD: __WEBPACK_IMPORTED_MODULE_3__modules_userDashboard_js__["a" /* default */],
      USER_AUTH: __WEBPACK_IMPORTED_MODULE_4__modules_authentication_js__["a" /* default */],
      NOTIFICATION: __WEBPACK_IMPORTED_MODULE_5__modules_userNotification_js__["a" /* default */],
      PROFILE: __WEBPACK_IMPORTED_MODULE_6__modules_userProfile_js__["a" /* default */]
   }
}));

/***/ }),

/***/ "pBDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var _this = this;

/* eslint-disable */


var profile = {
    namespaced: true,
    state: {
        info: [],
        imageInfo: []
    },
    getters: {},
    actions: {
        GET_PROFILE: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
                var commit = _ref2.commit;

                var _ref3, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/getemployeeinfo');

                            case 2:
                                _ref3 = _context.sent;
                                data = _ref3.data;

                                commit('SET_PROFILE', data);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function GET_PROFILE(_x) {
                return _ref.apply(this, arguments);
            };
        }(),

        GET_IMAGE: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5) {
                var commit = _ref5.commit;

                var _ref6, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/imageupload');

                            case 2:
                                _ref6 = _context2.sent;
                                data = _ref6.data;

                                commit('SET_IMAGE', data);

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }));

            return function GET_IMAGE(_x2) {
                return _ref4.apply(this, arguments);
            };
        }()
    },
    mutations: {
        SET_PROFILE: function SET_PROFILE(state, payload) {
            state.info = payload;
        },

        SET_IMAGE: function SET_IMAGE(state, payload) {
            state.imageInfo = payload;
        }

    }
};

/* harmony default export */ __webpack_exports__["a"] = (profile);

/***/ }),

/***/ "plEp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb arr-right"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/dashboard"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Dashboard\n      ")])],1),_vm._v(" "),_vm._l((_vm.breadcrumbs),function(item,index){return _c('li',{key:index,staticClass:"breadcrumb-item",class:{ active: _vm.isActive(item) }},[(!_vm.isActive(item))?_c('router-link',{attrs:{"to":item.path}},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")]):_c('span',[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qkp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppBreadcrumb',

  computed: {
    breadcrumbs: function breadcrumbs() {
      var crumbs = this.$route.meta && this.$route.meta.breadcrumbs;

      if (!Array.isArray(crumbs)) return [];

      return crumbs;
    }
  },

  methods: {
    isActive: function isActive(item) {
      var current = this.$route.path;

      if (current === item.path) return true;

      // dynamic routes only (naay :)
      if (this.$route.matched.some(function (r) {
        return r.path.includes(':');
      })) {
        return current.startsWith(item.path + '/');
      }

      return false;
    }
  }
});

/***/ }),

/***/ "uOQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_230557c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeletonTimeLoader_vue__ = __webpack_require__("2eGQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_230557c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeletonTimeLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uPMX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c1d924_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeletonDashboardLoader_vue__ = __webpack_require__("baav");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c1d924_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeletonDashboardLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wjG+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xLkP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.image)?_c('div',{staticClass:"card-image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xiKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumbs_vue__ = __webpack_require__("qkp6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225d50d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumbs_vue__ = __webpack_require__("plEp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225d50d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumbs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ye+V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3454fdf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeleltonChartLoader_vue__ = __webpack_require__("4PIV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3454fdf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkeleltonChartLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zvoi":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "Ibb5",
	"./af.js": "Ibb5",
	"./ar": "/pcG",
	"./ar-dz": "5U60",
	"./ar-dz.js": "5U60",
	"./ar-kw": "EwvT",
	"./ar-kw.js": "EwvT",
	"./ar-ly": "BfET",
	"./ar-ly.js": "BfET",
	"./ar-ma": "vOBJ",
	"./ar-ma.js": "vOBJ",
	"./ar-sa": "pb/n",
	"./ar-sa.js": "pb/n",
	"./ar-tn": "j0w3",
	"./ar-tn.js": "j0w3",
	"./ar.js": "/pcG",
	"./az": "JAq7",
	"./az.js": "JAq7",
	"./be": "0zJ3",
	"./be.js": "0zJ3",
	"./bg": "Gp3z",
	"./bg.js": "Gp3z",
	"./bm": "O3eJ",
	"./bm.js": "O3eJ",
	"./bn": "KEBb",
	"./bn-bd": "oL/x",
	"./bn-bd.js": "oL/x",
	"./bn.js": "KEBb",
	"./bo": "59rW",
	"./bo.js": "59rW",
	"./br": "bGFp",
	"./br.js": "bGFp",
	"./bs": "KhMA",
	"./bs.js": "KhMA",
	"./ca": "FMMf",
	"./ca.js": "FMMf",
	"./cs": "RZTa",
	"./cs.js": "RZTa",
	"./cv": "KKVe",
	"./cv.js": "KKVe",
	"./cy": "umKU",
	"./cy.js": "umKU",
	"./da": "DW8r",
	"./da.js": "DW8r",
	"./de": "b9Bu",
	"./de-at": "3rrq",
	"./de-at.js": "3rrq",
	"./de-ch": "Ank+",
	"./de-ch.js": "Ank+",
	"./de.js": "b9Bu",
	"./dv": "sVXn",
	"./dv.js": "sVXn",
	"./el": "0gY+",
	"./el.js": "0gY+",
	"./en-au": "WeZf",
	"./en-au.js": "WeZf",
	"./en-ca": "IquC",
	"./en-ca.js": "IquC",
	"./en-gb": "W/BM",
	"./en-gb.js": "W/BM",
	"./en-ie": "e4jh",
	"./en-ie.js": "e4jh",
	"./en-il": "Dvqi",
	"./en-il.js": "Dvqi",
	"./en-in": "IFZG",
	"./en-in.js": "IFZG",
	"./en-nz": "9gHz",
	"./en-nz.js": "9gHz",
	"./en-sg": "2YeO",
	"./en-sg.js": "2YeO",
	"./eo": "RDJ1",
	"./eo.js": "RDJ1",
	"./es": "yhKj",
	"./es-do": "0aYh",
	"./es-do.js": "0aYh",
	"./es-mx": "Vbd1",
	"./es-mx.js": "Vbd1",
	"./es-us": "SOZR",
	"./es-us.js": "SOZR",
	"./es.js": "yhKj",
	"./et": "sRJq",
	"./et.js": "sRJq",
	"./eu": "4d8i",
	"./eu.js": "4d8i",
	"./fa": "Z7k2",
	"./fa.js": "Z7k2",
	"./fi": "Hy+u",
	"./fi.js": "Hy+u",
	"./fil": "BkFM",
	"./fil.js": "BkFM",
	"./fo": "qzg0",
	"./fo.js": "qzg0",
	"./fr": "Nz7n",
	"./fr-ca": "VKK1",
	"./fr-ca.js": "VKK1",
	"./fr-ch": "EHtk",
	"./fr-ch.js": "EHtk",
	"./fr.js": "Nz7n",
	"./fy": "n68z",
	"./fy.js": "n68z",
	"./ga": "v4Vz",
	"./ga.js": "v4Vz",
	"./gd": "cbZb",
	"./gd.js": "cbZb",
	"./gl": "Cty6",
	"./gl.js": "Cty6",
	"./gom-deva": "FJ92",
	"./gom-deva.js": "FJ92",
	"./gom-latn": "heAV",
	"./gom-latn.js": "heAV",
	"./gu": "451i",
	"./gu.js": "451i",
	"./he": "/l4o",
	"./he.js": "/l4o",
	"./hi": "5D/8",
	"./hi.js": "5D/8",
	"./hr": "U0mu",
	"./hr.js": "U0mu",
	"./hu": "TdLU",
	"./hu.js": "TdLU",
	"./hy-am": "i0zi",
	"./hy-am.js": "i0zi",
	"./id": "+MHG",
	"./id.js": "+MHG",
	"./is": "trzO",
	"./is.js": "trzO",
	"./it": "xZbW",
	"./it-ch": "bnx5",
	"./it-ch.js": "bnx5",
	"./it.js": "xZbW",
	"./ja": "C/ak",
	"./ja.js": "C/ak",
	"./jv": "h72S",
	"./jv.js": "h72S",
	"./ka": "ryA9",
	"./ka.js": "ryA9",
	"./kk": "ir2x",
	"./kk.js": "ir2x",
	"./km": "OoZa",
	"./km.js": "OoZa",
	"./kn": "aP47",
	"./kn.js": "aP47",
	"./ko": "3ykJ",
	"./ko.js": "3ykJ",
	"./ku": "J6bG",
	"./ku.js": "J6bG",
	"./ky": "qDC4",
	"./ky.js": "qDC4",
	"./lb": "byKD",
	"./lb.js": "byKD",
	"./lo": "kGjE",
	"./lo.js": "kGjE",
	"./lt": "TDCn",
	"./lt.js": "TDCn",
	"./lv": "uA8+",
	"./lv.js": "uA8+",
	"./me": "ATD+",
	"./me.js": "ATD+",
	"./mi": "Yc/3",
	"./mi.js": "Yc/3",
	"./mk": "/p7c",
	"./mk.js": "/p7c",
	"./ml": "HLQx",
	"./ml.js": "HLQx",
	"./mn": "Kasd",
	"./mn.js": "Kasd",
	"./mr": "AxeG",
	"./mr.js": "AxeG",
	"./ms": "v4c1",
	"./ms-my": "pAnZ",
	"./ms-my.js": "pAnZ",
	"./ms.js": "v4c1",
	"./mt": "hP2h",
	"./mt.js": "hP2h",
	"./my": "ChaO",
	"./my.js": "ChaO",
	"./nb": "5DTO",
	"./nb.js": "5DTO",
	"./ne": "JaPp",
	"./ne.js": "JaPp",
	"./nl": "Qd+1",
	"./nl-be": "y3gW",
	"./nl-be.js": "y3gW",
	"./nl.js": "Qd+1",
	"./nn": "5dTJ",
	"./nn.js": "5dTJ",
	"./oc-lnc": "4dxQ",
	"./oc-lnc.js": "4dxQ",
	"./pa-in": "opiH",
	"./pa-in.js": "opiH",
	"./pl": "Cypk",
	"./pl.js": "Cypk",
	"./pt": "5aIa",
	"./pt-br": "4psY",
	"./pt-br.js": "4psY",
	"./pt.js": "5aIa",
	"./ro": "0xSN",
	"./ro.js": "0xSN",
	"./ru": "dUdM",
	"./ru.js": "dUdM",
	"./sd": "2M49",
	"./sd.js": "2M49",
	"./se": "6yRW",
	"./se.js": "6yRW",
	"./si": "o+pM",
	"./si.js": "o+pM",
	"./sk": "14S5",
	"./sk.js": "14S5",
	"./sl": "ePUO",
	"./sl.js": "ePUO",
	"./sq": "rFwo",
	"./sq.js": "rFwo",
	"./sr": "69kQ",
	"./sr-cyrl": "xFMA",
	"./sr-cyrl.js": "xFMA",
	"./sr.js": "69kQ",
	"./ss": "nGaS",
	"./ss.js": "nGaS",
	"./sv": "c4lX",
	"./sv.js": "c4lX",
	"./sw": "k8xk",
	"./sw.js": "k8xk",
	"./ta": "XBpM",
	"./ta.js": "XBpM",
	"./te": "OuOc",
	"./te.js": "OuOc",
	"./tet": "ObL+",
	"./tet.js": "ObL+",
	"./tg": "L8V3",
	"./tg.js": "L8V3",
	"./th": "7Hye",
	"./th.js": "7Hye",
	"./tk": "b7Mn",
	"./tk.js": "b7Mn",
	"./tl-ph": "HbHT",
	"./tl-ph.js": "HbHT",
	"./tlh": "2jx0",
	"./tlh.js": "2jx0",
	"./tr": "Y1B2",
	"./tr.js": "Y1B2",
	"./tzl": "tMZK",
	"./tzl.js": "tMZK",
	"./tzm": "phQf",
	"./tzm-latn": "kYig",
	"./tzm-latn.js": "kYig",
	"./tzm.js": "phQf",
	"./ug-cn": "0zX+",
	"./ug-cn.js": "0zX+",
	"./uk": "0hD+",
	"./uk.js": "0hD+",
	"./ur": "SI6o",
	"./ur.js": "SI6o",
	"./uz": "z4oe",
	"./uz-latn": "yuEK",
	"./uz-latn.js": "yuEK",
	"./uz.js": "z4oe",
	"./vi": "DzzS",
	"./vi.js": "DzzS",
	"./x-pseudo": "WH0j",
	"./x-pseudo.js": "WH0j",
	"./yo": "HRs9",
	"./yo.js": "HRs9",
	"./zh-cn": "DUHk",
	"./zh-cn.js": "DUHk",
	"./zh-hk": "FZoV",
	"./zh-hk.js": "FZoV",
	"./zh-mo": "bFND",
	"./zh-mo.js": "bFND",
	"./zh-tw": "vCZs",
	"./zh-tw.js": "vCZs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zvoi";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.abb96f42940b84910156.js